<template>
    <v-container grid-list-md>
        <v-card-title>
            <h1>Governors-General and Statutory Office Holders</h1>
        </v-card-title>
            <v-list>
                <template v-for="(item, index) in items">
                    <v-divider v-if="index !== 0" :key="index"></v-divider>
                    <v-list-tile :key="item.title">
                        <v-list-tile-content>
                            <v-list-tile-title>
                                <router-link :to="{ name: item.route }">
                                    {{ item.title }}
                                </router-link>
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
  
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            items: [
                { title: 'Governors-General', route: 'GovernorsGeneral' },
                { title: 'Presidents and Deputy Presidents', route: 'Presidents' },
                { title: 'Speakers and Deputy Speakers', route: 'Speakers' },
                { title: 'Parliamentary Statutory Office Holders', route: 'OfficeHolders' }
            ]
        }
    }
}
</script>

<style scoped>
    a {
        text-decoration: none;
    }
</style>